import { useEffect, useState } from "react";
import { PreviewButton } from "@/components/PdfPreview";
import { toast } from "sonner";
import { Plus, FileDown, Pencil, Trash2, FileSpreadsheet } from "lucide-react";
import api, { errMsg, download } from "@/lib/api";
import { fdate } from "@/lib/fmt";
import { Button } from "@/components/ui/button";
import { TechDocForm, TITLES } from "@/components/tech/TechDocForm";

export const TechDocs = ({ type }) => {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(undefined);
  const load = () => api.get("/tech/docs", { params: { type } }).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [type]); // eslint-disable-line react-hooks/exhaustive-deps
  const del = async (d) => {
    if (!window.confirm(`Hapus ${d.doc_no}?`)) return;
    try { await api.delete(`/tech/docs/${d.id}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const pdf = (d) => download(`/tech/docs/${d.id}/pdf`, {}, `${d.doc_no.replace(/[^A-Za-z0-9-]+/g, "-")}.pdf`).catch((e) => toast.error(errMsg(e)));
  const xlsx = (d) => download(`/tech/docs/${d.id}/xlsx`, {}, `${d.doc_no.replace(/[^A-Za-z0-9-]+/g, "-")}.xlsx`).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="space-y-3" data-testid={`tech-docs-${type}`}>
      <Button onClick={() => setEdit(null)} data-testid={`tech-new-${type}-btn`}><Plus className="h-4 w-4 mr-1" />Buat {TITLES[type]}</Button>
      {!rows.length && <p className="rounded-xl border border-dashed p-8 text-center text-sm text-slate-400">Belum ada dokumen.</p>}
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {rows.map((d) => (
          <div key={d.id} className="card-premium p-4" data-testid={`tech-doc-${d.id}`}>
            <p className="font-num text-xs font-semibold text-blue-900">{d.doc_no}</p>
            <p className="mt-1 font-semibold">{d.client || "-"}</p>
            <p className="text-sm text-slate-500">{d.project || "-"}</p>
            <p className="mt-1 text-xs text-slate-400">{fdate(d.date)} • {d.created_by_name}{type !== "bast" && ` • ${d.rows?.length || 0} baris`}</p>
            <div className="mt-3 flex gap-2">
              <PreviewButton size="sm" url={`/tech/docs/${d.id}/pdf`} filename={`${d.doc_no.replace(/[^A-Za-z0-9-]+/g, "-")}.pdf`} title={d.doc_no} testId={`tech-preview-${d.id}`} />
              <Button size="sm" onClick={() => pdf(d)} data-testid={`tech-pdf-${d.id}`}><FileDown className="h-4 w-4 mr-1" />PDF</Button>
              <Button size="sm" variant="outline" onClick={() => xlsx(d)} data-testid={`tech-xlsx-${d.id}`}><FileSpreadsheet className="h-4 w-4 mr-1" />Excel</Button>
              <Button size="sm" variant="outline" onClick={() => setEdit(d)} data-testid={`tech-edit-${d.id}`}><Pencil className="h-4 w-4 mr-1" />Edit</Button>
              <Button size="icon" variant="ghost" className="text-rose-500" onClick={() => del(d)} data-testid={`tech-delete-${d.id}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          </div>
        ))}
      </div>
      <TechDocForm type={type} doc={edit} open={edit !== undefined} onClose={() => setEdit(undefined)} onSaved={() => { setEdit(undefined); load(); }} />
    </div>
  );
};
